// From https://github.com/foxhound87/mobx-react-form-demo/tree/master/src/components/inputs
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { observer, inject } from 'mobx-react';

// export default observer(({ field, type = 'text', placeholder = null }) => (
@inject('auth') @observer
class SimpleInput extends Component {
    render() {
        const { intl: { formatMessage } } = this.props;
        const { field, type = null, placeholder = null } = this.props;
        const intlPlaceholder = placeholder ? formatMessage({ id: placeholder }) :
            field.placeholder ? formatMessage({ id: field.placeholder }) : null;
        const typeOfField = type || field.type || 'text';

        return (
            <div className={`form-group mt-2 mb-2${field.error ? ' has-danger' : ''}`}>
                <label
                    htmlFor={field.id}
                    className="form-control-label sr-only"
                >
                    <FormattedMessage id={field.label} defaultMessage={intlPlaceholder} />
                </label>
                <input
                    className={`form-control${field.error ? ' form-control-danger' : ''}`}
                    aria-describedby="name-desc"
                    {...field.bind({ typeOfField, placeholder: intlPlaceholder })}
                />

                <small className="form-control-feedback">
                    {field.error}
                </small>
            </div>);
    }
}

SimpleInput.wrappedComponent.propTypes = {
    field: PropTypes.object.isRequired,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    intl: PropTypes.object.isRequired,
};
SimpleInput.defaultProps = {
    type: 'text',
    placeholder: '',
};

export default injectIntl(SimpleInput);
